import { ChipArrayField } from 'admin/fields/ChipArrayField';
import { Datagrid, DateField, DeleteButton, EditButton, ReferenceField, SelectField, TextField } from 'react-admin';

import { SERVICE_AREA_TYPES, USER_RELATION_TYPES } from './userRelationUtils';

export const UserRelationDatagrid: React.FC = () => {
  return (
    <Datagrid bulkActionButtons={false} rowClick="show">
      <TextField label="ID" source="id" />
      <ReferenceField label="Kto" link="show" reference="User" source="subjectUser.id">
        <TextField source="email" />
      </ReferenceField>
      <SelectField choices={USER_RELATION_TYPES} label="Má vzťah" source="relationType" />
      <ReferenceField label="Ku komu" link="show" reference="User" source="objectUser.id">
        <TextField source="email" />
      </ReferenceField>
      <ChipArrayField choices={SERVICE_AREA_TYPES} label="V oblastiach" source="serviceAreas" />
      <DateField label="Dátum vytvorenia" locales="sk" source="creationTimestamp" />
      <DateField label="Dátum zmeny" locales="sk" source="updateTimestamp" />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  );
};
